interface Props {
  checked: boolean;
  onSelect: () => void;
  label: string;
  disabled?: boolean;
}

const OneOption: React.FC<Props> = ({ checked, onSelect, label, disabled }) => {
  return (
    <div
      onClick={onSelect}
      className={`add-on ${checked ? "add-on-selected" : "add-on-not-selected"}`}
      style={{ lineHeight: 0, cursor: disabled ? "not-allowed" : "pointer" }}
    >
      {label}
    </div>
  );
};

export default OneOption;
